import $ from 'jquery';


function getObject(name) {
  try {
    return JSON.parse(getItem(name));
  } catch (e) {
    // continue regardless of error
  }
}

function setObject(name, value) {
  setItem(name, JSON.stringify(value));
}

function getItem(name) {
  return window.localStorage.getItem(name);
}

function setItem(name, value) {
  try {
    window.localStorage.setItem(name, value);
  } catch (e) {
    // continue regardless of error
  }
}

function getSessionItem(name) {
  return window.sessionStorage.getItem(name);
}

function setSessionItem(name, value) {
  try {
    window.sessionStorage.setItem(name, value);
  } catch (e) {
    // continue regardless of error
  }
}

function getSessionObject(name) {
  try {
    return $.parseJSON(getSessionItem(name));
  } catch (e) {
    // continue regardless of error
  }
}

function setSessionObject(name, value) {
  try {
    setSessionItem(name, JSON.stringify(value));
  } catch (e) {
    // continue regardless of error
  }
}

export default {
  get: getItem,
  set: setItem,
  getObject: getObject,
  setObject: setObject,
  setSession: setSessionItem,
  getSession: getSessionItem,
  getSessionObject: getSessionObject,
  setSessionObject: setSessionObject
};



// WEBPACK FOOTER //
// ./web/js/storage.js